import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/IconButton/sgds-icon-button";
import { register } from "../../utils/ce-registry";

register("sgds-icon-button", Component);

export default createComponent({
  react: React,
  tagName: "sgds-icon-button",
  elementClass: Component,
  events: {
    onSgdsBlur: "sgds-blur",
    onSgdsFocus: "sgds-focus"
  }
});
